'use client'

import { useEffect, useRef } from 'react'
import { useInView, useMotionValue, useSpring } from 'framer-motion'

type Props = {
  value: number
  className?: string
  stiffness?: number
}

export default function Counter({ value, className, stiffness = 800 }: Props) {
  const ref = useRef<HTMLSpanElement>(null)
  const motionValue = useMotionValue(0)
  const springValue = useSpring(motionValue, {
    stiffness,
    damping: 100,
    mass: 1,
  })
  const isInView = useInView(ref, { once: true, amount: 'all' })

  useEffect(() => {
    if (isInView) {
      motionValue.set(value)
    }
  }, [motionValue, isInView, value])

  useEffect(
    () =>
      springValue.on('change', (latest) => {
        if (ref.current) {
          ref.current.textContent = Intl.NumberFormat('en-US').format(
            Math.round(latest),
          )
        }
      }),
    [springValue],
  )

  return <span className={className} ref={ref} />
}
